import { render, staticRenderFns } from "./DashboardFid.vue?vue&type=template&id=d255b612&"
import script from "./DashboardFid.vue?vue&type=script&lang=js&"
export * from "./DashboardFid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports